<template>
  <div class="text-secondary text-mr">
    <div>
      {{ $t('You’re about to remove') }} {{ userName }}
      {{ $t('from the project. Now they are responsible for the following tenders') }}:
      <ul>
        <li v-for="(tender, idx) in tenders" :key="idx">{{ tender.name }}</li>
      </ul>
    </div>
    <div class="mb-8">
      {{
        $t('Select a person who will be set as the new representative for those tenders instead.')
      }}
    </div>
    <Select
      v-model="selectedUser"
      :label-text="$t('The new representative of the tenders')"
      :items="team"
      @input="changeData({ key: 'selectedUser', value: $event })"
    />
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex';
  import Select from '@/components/ui/Select';

  export default {
    name: 'TransferResponsibility',
    components: {
      Select,
    },
    data() {
      return {
        selectedUser: '',
      };
    },
    computed: {
      ...mapState('confirmModal', ['context']),
      tenders() {
        return this.context?.data.tenders || [];
      },
      userName() {
        return (
          this.context?.data.user?.name || this.context?.data.user?.email || this.$t('teammate')
        );
      },
      team() {
        return (this.context?.data.team || [])
          .filter((member) => member.user.id !== this.context?.data.user.id)
          .map((member) => {
            return {
              value: member.user.id,
              text: this.getMemberTitle(member),
            };
          });
      },
    },
    methods: {
      ...mapMutations('confirmModal', ['changeData']),
      getMemberTitle(member) {
        return member.user.name ? `${member.user.name} (${member.role})` : member.user.email;
      },
    },
  };
</script>

<style scoped>
  ul {
    padding-left: 20px;
  }
</style>
